"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatorsImportService = void 0;
class CreatorsImportService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Import creator csv information
     * import csv of creators -
     * any existing creators will simply updated with the provided info
     * any non existing will be created with their channel
     * currently supported platforms: tiktok
     * @returns ImportCreatorCSVLineResponse
     * @throws ApiError
     */
    importCsvCreators() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/creators/import/csv',
        });
    }
    /**
     * Update creator csv information
     * @returns ImportCreatorCSVLineResponse
     * @throws ApiError
     */
    updateCreators() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/creators/import/update/csv',
        });
    }
    /**
     * Update creator verified creator email csv information
     * @returns ImportCreatorCSVLineResponse
     * @throws ApiError
     */
    updateVerifiedCreatorEmail() {
        return this.httpRequest.request({
            method: 'POST',
            url: '/creators/import/email/csv',
        });
    }
}
exports.CreatorsImportService = CreatorsImportService;
